jQuery(window).on('load', function () {
    function init(){
        $("#subscribeToPlan").click(function (e) {
            var planId = $(this).data('plan-id');
            var userId = $(this).data('user-id');
            var promo_code = $("#promo_code_check").val();
            var price = $("#price").val();

            $.post($('body').data('base-url') + "subscriptions/add/" + userId, {userId: userId, planId: planId, promo_code: promo_code, price:price}).done(function(responseText) {
                var res = JSON.parse(responseText);

                if(res.status === true) {
                    Materialize.toast(res.msg, 2000);
                    setTimeout(function(){
                        if (location.pathname.indexOf('#subscriptions') !== -1)
                            location.href = window.location.href+"#subscriptions";
                        location.reload();
                    }, 1000);
                } else {
                    Materialize.toast(res.msg, 2000);
                }
            });
        });

        $("#unsubscribeToPlan").click(function (e) {
            var planId = $(this).data('plan-id');
            var userId = $(this).data('user-id');
            var subId = $(this).data('subscription-id');

            $.post($('body').data('base-url') + "subscriptions/remove/" + userId, {userId: userId, planId: planId, subId:subId}).done(function(responseText) {
                var res = JSON.parse(responseText);

                if(res.status === true) {
                    Materialize.toast(res.msg, 2000);

                    setTimeout(function(){
                        if (location.pathname.indexOf('#subscriptions') !== -1)
                            location.href = window.location.href+"#subscriptions";
                        location.reload();
                    }, 1000);
                } else {
                    Materialize.toast(res.msg, 2000);
                }
            });
        });

        $("#subscribeAgainToPlan").click(function (e) {
            var planId = $(this).data('plan-id');
            var userId = $(this).data('user-id');
            var subId = $(this).data('subscription-id');

            $.post($('body').data('base-url') + "subscriptions/addAgain/" + userId, {userId: userId, planId: planId, subId:subId}).done(function(responseText) {
                var res = JSON.parse(responseText);

                if(res.status === true) {
                    Materialize.toast(res.msg, 2000);

                    setTimeout(function(){
                        if (location.pathname.indexOf('#subscriptions') !== -1)
                            location.href = window.location.href+"#subscriptions";
                        location.reload();
                    }, 1000);
                } else {
                    Materialize.toast(res.msg, 2000);
                }
            });
        });

        $("#subscribeToAccountPlan").click(function (e) {
            var planId = $(this).data('plan-id');
            var userId = $(this).data('user-id');
            var promo_code = $("#promo_code_check").val();
            var price = $("#price").val();
            var user_total = $("#user_total").val();

            $.post($('body').data('base-url') + "subscriptions/addAccountSubscription/" + userId, {userId: userId, planId: planId, promo_code: promo_code, price:price, user_total:user_total}).done(function(responseText) {
                var res = JSON.parse(responseText);

                if(res.status === true) {
                    Materialize.toast(res.msg, 2000);
                    setTimeout(function(){
                        if (location.pathname.indexOf('#subscriptions') !== -1)
                            location.href = window.location.href+"#subscriptions";
                        location.reload();
                    }, 1000);
                } else {
                    Materialize.toast(res.msg, 2000);
                }
            });
        });

        $("#unsubscribeToAccountPlan").click(function (e) {
            var planId = $(this).data('plan-id');
            var userId = $(this).data('user-id');
            var subId = $(this).data('subscription-id');

            $.post($('body').data('base-url') + "subscriptions/removeAccountSubscription/" + userId, {userId: userId, planId: planId, subId:subId}).done(function(responseText) {
                var res = JSON.parse(responseText);

                if(res.status === true) {
                    Materialize.toast(res.msg, 2000);

                    setTimeout(function(){
                        if (location.pathname.indexOf('#subscriptions') !== -1)
                            location.href = window.location.href+"#subscriptions";
                        location.reload();
                    }, 1000);
                } else {
                    Materialize.toast(res.msg, 2000);
                }
            });
        });

        $("#subscribeAgainToAccountPlan").click(function (e) {
            var planId = $(this).data('plan-id');
            var userId = $(this).data('user-id');
            var subId = $(this).data('subscription-id');

            $.post($('body').data('base-url') + "subscriptions/addAccountSubscriptionAgain/" + userId, {userId: userId, planId: planId, subId:subId}).done(function(responseText) {
                var res = JSON.parse(responseText);

                if(res.status === true) {
                    Materialize.toast(res.msg, 2000);

                    setTimeout(function(){
                        if (location.pathname.indexOf('#subscriptions') !== -1)
                            location.href = window.location.href+"#subscriptions";
                        location.reload();
                    }, 1000);
                } else {
                    Materialize.toast(res.msg, 2000);
                }
            });
        });
        $("#removeToAccountPlan").click(function (e) {
            e.preventDefault();
            var accountid = $(this).attr('data-id');
            deleteConfirm(function () {
                startLoading('body');
                request = $.ajax({
                    type: 'GET', // your request type
                    url: $('body').data('base-url')+'payments/delete/'+ accountid,
                    data: {},
                    success: function (response) {
                        Materialize.toast(response, 3000);
                        location.reload();
                    },
                    complete: function () {
                        runningRequest = false;
                    }
                });
            });
        });
        $("#removeToUserPlan").click(function (e) {
            e.preventDefault();
            var userid = $(this).attr('data-id');
            deleteConfirm(function () {
                startLoading('body');
                request = $.ajax({
                    type: 'GET', // your request type
                    url: $('body').data('base-url')+'payment-method/delete/'+ userid,
                    data: {},
                    success: function (response) {
                        Materialize.toast(response, 3000);
                        location.reload();
                    },
                    complete: function () {
                        runningRequest = false;
                    }
                });
            });
        });
    }

    init();
});